import React  from 'react'
import ErrorMessage from '../../../Elements/ErrorMessage';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import ApolloDataExportHistoryService from '../../../Services/ApolloDataExportHistoryService';


class ApolloDataExportHistoryComponent extends React.Component 
{

    static defaultProps={
        apolloDataExportId: 1,
    };

    constructor(props) 
    {
        super(props);
        this.state = {
            itemList:[],
            loading: true,
        };
    }

    componentDidMount() 
    {
        this.populateCommentListData();
    }

    async populateCommentListData () 
    {
        this.setState({loading:true});
        ApolloDataExportHistoryService.GetHistory(this.props.apolloDataExportId)
        .then(result =>
        {
            this.setState(
                {
                    itemList: ApolloDataExportHistoryService.ConvertDBItems(result),
                    loading: false,
                });
        })
        .catch(() => ErrorMessage.SetErrorMessage("ADEHC40"));
    }

    render()
    {
        return (
            <div>
                {
                    this.state.itemList.map(item=>
                            <p>{dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.CreatedOn)}: {item.EventDescription}</p>
                        )
                }
            </div>
        );
    }
}


export default ApolloDataExportHistoryComponent;
